import { Box } from '@chakra-ui/react'
import type { ChildTicketTask } from '@/lib/services/childTicketService'
import TaskPipelinePreview from './TaskPipelinePreview'

type Props = {
  tasks: ChildTicketTask[]
  onTaskClick?: (task: ChildTicketTask) => void
}

export default function TaskPipelineView({ tasks, onTaskClick }: Props) {
  if (tasks.length === 0) {
    return null
  }

  return (
    <Box>
      <TaskPipelinePreview tasks={tasks} onTaskClick={onTaskClick} />
    </Box>
  )
}
